export default "/images/90ffc3325c2c1182ae8bd81b35bba99e.avif";